const danhSachGroup = state => state.danhSachGroup;
const danhSachGroupPaging = state => state.danhSachGroupPaging;
const chiTietGroup = state => state.chiTietGroup;
const danhSachVaiTroTheoGroup = state => state.danhSachVaiTroTheoGroup;
const danhSachQuyenTheoGroup = state => state.danhSachQuyenTheoGroup;
const danhSachUserNotInGroup = state => state.danhSachUserNotInGroup;

export default {
    danhSachGroup,
    danhSachGroupPaging,
    chiTietGroup,
    danhSachVaiTroTheoGroup,
    danhSachQuyenTheoGroup,
    danhSachUserNotInGroup
};
